<template>
  <div
    class="footview"
    :style="{
      'padding-left': isWideScreen ? '10%' : '5%',
      'padding-right': isWideScreen ? '10%' : '5%',
      'padding-top': '30px',
      'padding-bottom': '20px',
    }"
  >
    <el-container>
      <!-- Logo 和版权信息 -->
      <el-row gutter="15" style="">
        <el-col :span="10">
          <div class="footer-logo">
            <img
              src="https://wgx-bucket.oss-ap-southeast-1.aliyuncs.com/logo.png"
              alt="Logo"
            />
          </div>
        </el-col>
        <el-col :span="14" style="">
          <div class="footer-title" style="height: 100%; padding-top: 3px">
            <div style="font-size: 28px; font-weight: bold">{{ $t("title") }}</div>
            <div style="color: gray">{{ $t("home.smartcontrol") }}</div>
          </div>
        </el-col>
      </el-row>
    </el-container>
    <div style="text-align: left">
      <p style="font-size: small">{{ $t("footer.email") }}：support@capturedslr.cc</p>

    </div>
    <div style="font-size: 12px; color: gray; text-align: center; cursor:pointer;" @click="goBeianAction"> 
      豫ICP备2024060760号-4
    </div>
  </div>
</template>

<script>
import { Container, Row, Col, Input, Button } from "element-ui";
export default {
  name: "FooterView",
  components: {
    "el-row": Row,
    "el-col": Col,
    "el-input": Input,
    "el-button": Button,
    "el-container": Container,
  },
  data() {
    return {
      email: "",
    };
  },
  props: {
    isWideScreen: Boolean,
  },
  methods: {
    goBeianAction() {
      window.open("http://beian.miit.gov.cn/");
    },
  }
};
</script>


<style>
.footview {
  margin: 0;
  /* padding: 0; */
  /* width: 100%; */
  text-align: center;
  align-content: center;
  align-items: center;
  /* height: 00px; */
  background-color: #f7f9fa;
}
.site-footer {
  background-color: #f5f5f5;
  padding: 20px 0;
}

.footer-logo img {
  max-width: 70px;
  /* margin-bottom: 10px; */
}
.footer-title {
  text-align: left;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/FooterView.vue